module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/quantum-phone-video-poster.204c7c52.jpg";